// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "iframe{border:0;overflow:hidden;margin:0 auto;display:block}", ""]);
// Exports
module.exports = exports;
